import { Helmet } from "react-helmet-async";
import { ScreenshotGenerator } from "../screenshot-generator/ScreenshotGenerator.tsx";

export function ScreenshotPage() {
  return (
    <>
      <Helmet>
        <title>Screenshot Generator - ShootCreator</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <ScreenshotGenerator />
    </>
  );
}
